import axios from '../axios'

/*
 * 數據模塊
 */
// 搜索字典
export const findByType = (data) => {
    return axios({
		url: '/api/dictionary/findItemByDictionaryType',
		method: 'get',
		params:data
    })
};

// 按部位查找
export const findTemplateBase = (data) => {
	return axios({
		url: '/api/template/find_base_by',
		method: 'post',
		data:data
	})
};



// 按方法查找
export const findPlaceBase = (data) => {
	return axios({
		url: '/api/template/find_place_by',
		method: 'post',
		data:data
	})
};




// WEBPACK FOOTER //
// ./src/http/moudules/dictionary.js